var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDataAnalytics(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 145.02 155.79",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient-6);}.cls-1,.cls-2,.cls-3,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8,.cls-9,.cls-10{stroke:#fff;}.cls-1,.cls-2,.cls-3,.cls-5,.cls-6,.cls-7,.cls-8,.cls-9,.cls-10{stroke-width:3px;}.cls-1,.cls-2,.cls-3,.cls-5,.cls-7,.cls-8,.cls-9{stroke-miterlimit:10;}.cls-2{fill:none;}.cls-3{fill:url(#linear-gradient-8);}.cls-4{fill:#7da2fe;stroke-width:2px;}.cls-4,.cls-6,.cls-10{stroke-linecap:round;stroke-linejoin:round;}.cls-5{fill:url(#linear-gradient-5);}.cls-6{fill:url(#linear-gradient-2);}.cls-6,.cls-10{fill-opacity:.44;}.cls-7{fill:url(#linear-gradient-7);}.cls-8{fill:url(#linear-gradient-3);}.cls-9{fill:url(#linear-gradient-4);}.cls-10{fill:url(#linear-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 8.51,
    y1: 99.02,
    x2: 34.11,
    y2: 99.02,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#386aff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1b86f6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 34.11,
    y1: 65.98,
    x2: 59.71,
    y2: 65.98,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 27.1,
    y1: 89.35,
    x2: 41.11,
    y2: 89.35,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 1.5,
    y1: 108.7,
    x2: 15.51,
    y2: 108.7,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 52.71,
    y1: 42.62,
    x2: 66.72,
    y2: 42.62,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 78.31,
    y1: 49.62,
    x2: 92.32,
    y2: 49.62,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 103.91,
    y1: 8.51,
    x2: 117.92,
    y2: 8.51,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 129.51,
    y1: 25.06,
    x2: 143.52,
    y2: 25.06,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 40.72,
    y: 106.79,
    width: 12.37,
    height: 48
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 15.12,
    y: 127.4,
    width: 12.37,
    height: 27.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 66.33,
    y: 64.23,
    width: 12.37,
    height: 90.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 91.93,
    y: 73.74,
    width: 12.37,
    height: 81.06
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 117.53,
    y: 41.13,
    width: 12.37,
    height: 113.66
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 8.51,
    y1: 108.7,
    x2: 34.11,
    y2: 89.35
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 34.11,
    y1: 89.35,
    x2: 59.71,
    y2: 42.62
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 34.11,
    cy: 89.35,
    r: 7.01
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 8.51,
    cy: 108.7,
    r: 7.01
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 59.71,
    y1: 42.62,
    x2: 85.31,
    y2: 49.62
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 59.71,
    cy: 42.62,
    r: 7.01
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 85.31,
    y1: 49.62,
    x2: 110.92,
    y2: 8.51
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 85.31,
    cy: 49.62,
    r: 7.01
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 110.92,
    y1: 8.51,
    x2: 136.52,
    y2: 25.06
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 110.92,
    cy: 8.51,
    r: 7.01
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 136.52,
    cy: 25.06,
    r: 7.01
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataAnalytics);
export default __webpack_public_path__ + "static/media/data-analytics.c5edb879990c4ff692d786a9bc760630.svg";
export { ForwardRef as ReactComponent };